import { createElement } from 'react';
import { Decoration1, Decoration2, Decoration3, Decoration4, Decoration5, Decoration6, Decoration7, Decoration8, Decoration9, Decoration10, Decoration11, } from '@jiaminghi/data-view-react';
const DataVDecoration = (props) => {
    const { children, decorationType = '1', ...rest } = props;
    const ComponentMaps = {
        '1': Decoration1,
        '2': Decoration2,
        '3': Decoration3,
        '4': Decoration4,
        '5': Decoration5,
        '6': Decoration6,
        '7': Decoration7,
        '8': Decoration8,
        '9': Decoration9,
        '10': Decoration10,
        '11': Decoration11,
    };
    const filterChildType = ['7', '9', '11'];
    const Decoration = ComponentMaps[decorationType];
    if (filterChildType.includes(decorationType)) {
        return createElement(Decoration, { ...rest }, children);
    }
    return (createElement("div", { style: { ...rest.style, position: 'relative', zIndex: 2 } },
        createElement("span", { style: { position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 1 } },
            createElement(Decoration, { ...rest, style: { width: '100%', height: '100%' } })),
        createElement("span", { style: { position: 'relative', zIndex: 3 } }, children)));
};
export default DataVDecoration;
